import { createPortal } from 'react-dom';
import './catchUpCover.css';

/** Blocks the live window, header included, while catch-up is in flight. */
export default function CatchUpCover(): JSX.Element {
  return createPortal(
    <div className="catch-up-cover" role="status" aria-live="polite">
      <span className="catch-up-mark" aria-hidden="true" />
      <p className="catch-up-text">Catching up on the world...</p>
    </div>,
    document.body,
  );
}
